import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-six-three-two',
  templateUrl: './two-six-three-two.component.html',
  styleUrls: ['./two-six-three-two.component.scss']
})
export class TwoSixThreeTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
